var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4756 0.5V4.5H22.4756",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47467 8.47736V1.30558C5.47339 1.09472 5.55533 0.891856 5.7027 0.741034C5.85007 0.590212 6.05098 0.503601 6.26182 0.5H18.4745C18.5627 0.502233 18.6492 0.524553 18.7275 0.565261C18.8058 0.605969 18.8737 0.663994 18.9262 0.73492L22.2386 4.00357C22.3119 4.06401 22.371 4.13979 22.4117 4.22557C22.4525 4.31135 22.4739 4.40503 22.4745 4.5V22.7001C22.4748 22.9109 22.3918 23.1133 22.2435 23.2631C22.0953 23.4129 21.8938 23.4981 21.683 23.5H6.26182C6.05154 23.4978 5.8507 23.4124 5.70319 23.2625C5.55569 23.1126 5.47351 22.9104 5.47462 22.7001V14.4777",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23552 14.5854C2.71779 14.5854 3.10874 14.1945 3.10874 13.7122C3.10874 13.2299 2.71779 12.839 2.23552 12.839C1.75326 12.839 1.3623 13.2299 1.3623 13.7122C1.3623 14.1945 1.75326 14.5854 2.23552 14.5854Z",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37224 10.3168C8.85451 10.3168 9.24546 9.9258 9.24546 9.44353C9.24546 8.96127 8.85451 8.57031 8.37224 8.57031C7.88998 8.57031 7.49902 8.96127 7.49902 9.44353C7.49902 9.9258 7.88998 10.3168 8.37224 10.3168Z",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.508 18.2546C13.9903 18.2546 14.3812 17.8637 14.3812 17.3814C14.3812 16.8991 13.9903 16.5082 13.508 16.5082C13.0257 16.5082 12.6348 16.8991 12.6348 17.3814C12.6348 17.8637 13.0257 18.2546 13.508 18.2546Z",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6447 12.6515C19.127 12.6515 19.5179 12.2605 19.5179 11.7782C19.5179 11.296 19.127 10.905 18.6447 10.905C18.1624 10.905 17.7715 11.296 17.7715 11.7782C17.7715 12.2605 18.1624 12.6515 18.6447 12.6515Z",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64573 9.92786L2.9707 13.2444",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8457 10.1755L13.0346 16.6493",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0967 16.7398L18.0428 12.4349",
    stroke: "#394553",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportKpi);
export default __webpack_public_path__ + "static/media/report_kpi.3298fd76927dda57de7d12fdbc41751f.svg";
export { ForwardRef as ReactComponent };